const aspects = [
  [
    ["C- Caudate (1)"], "caudate", 0, 1
  ],
  [
    ["I - Insular Ribbon (1)"], "insularribbon", 0, 1
  ],
  [
    ["IC - Internal Capsule (1)"], "internalcapsule", 0, 1
  ],
  [
    ["L - Lentiform nucleus (1)"], "lentiformnucleus", 0, 1
  ],
  [
    ["M1 - Anterior MCA Cortex (1)"], "m1", 0, 1
  ],
  [
    ["M2 - MCA Cortex lateral to Insular Ribbon (1)"], "m2", 0, 1
  ],
  [
    ["M3 - Posterior MCA Cortex (1)"], "m3", 0, 1
  ],
  [
    ["M4 - Anterior MCA Superior Territory (1)"], "m4", 0, 1
  ],
  [
    ["M5 - Lateral MCA Superior Territory (1)"], "m5", 0, 1
  ],
  [
    ["M6 - Posterior MCA Superior Territory (1)"], "m6", 0, 1
  ]
];

export const aspectsItems = [
  ["ASPECTS Score in Acute Stroke", aspects]
];
